import './style.css'
import Experience from './Experience/Experience.js'
import ZhuyuPage from './Experience/ZhuyuPage.js'

window.experience = new Experience({
    targetElement: document.querySelector('.experience')
})

new ZhuyuPage()
